import UserDTO from './user';

export enum EventTransactionType {
  SellerExpense = 'SELLER_EXPENSE',
  CashIn = 'CASH_IN',
  CashOut = 'CASH_OUT',
}

export const EVENT_TRANSACTION_TYPE_LABELS: Record<EventTransactionType, string> = {
  [EventTransactionType.SellerExpense]: 'Gasto de vendedor',
  [EventTransactionType.CashIn]: 'Ingreso de efectivo',
  [EventTransactionType.CashOut]: 'Retiro de efectivo',
};

export interface EventTransactionDTO {
  id: string;
  event_id: string;
  user_id: string;
  is_seller_expense: boolean;
  amount: number;
  type: EventTransactionType;
  description: string;
  created_at: string;
  user: UserDTO;
}

export type CreateEventTransactionDTO = Pick<EventTransactionDTO,
'user_id' |
'is_seller_expense' |
'amount' |
'type' |
'description'
>;

export interface EventTransactionSummaryDTO {
  transactions: EventTransactionDTO[];
  total_amount: number;
}
